import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const withCanvasBackground = (className?: string): string =>
  cn("bg-canvas canvas-grid", className);

